export default "__VITE_ASSET__Df6q9fOo__"